import { render, staticRenderFns } from "./approveRecordDialog.vue?vue&type=template&id=52b7ea78&scoped=true&"
import script from "./approveRecordDialog.vue?vue&type=script&lang=js&"
export * from "./approveRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveRecordDialog.vue?vue&type=style&index=0&id=52b7ea78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7ea78",
  null
  
)

export default component.exports